module.exports = __webpack_public_path__ + "img/appleM.1e3c42ce.png";